// extracted by mini-css-extract-plugin
export default {"button":"ButtonLine_button__PRdU5","light":"ButtonLine_light__AIStt"};